import { Anchor, type _Navigation } from ":setup/qrouter";
import { default as routes } from "../routes";
import { global } from ":shared/app";
import { LockedAnchor } from ":src/components/overlays";
export default function HelpCenter(props: _Navigation.SideNavJSXItemProps) {
  const $settings = global.store.hooks.platform.useSettings("support");
  return (
    <Anchor
      class={props.anchor?.class}
      setup={{
        to: routes,
        classes: {
          active: `${props.anchor.setup.classes.active}`,
        },
      }}
      components={{
        title: "Help & FAQ",
        idleIcon: <i class="i-mdi:message-question-outline" />,
        activeIcon: <i class="i-mdi:message-question-outline" />,
      }}
      events={{
        getShouldNavigate() {
          return !$settings().locked;
        },
      }}
    >
      <LockedAnchor locked={$settings().locked} />
    </Anchor>
  );
}
